import React, { useEffect, useState } from "react";
import Container from "../../../components/Container";
import { BtnPadrao, BtnDeletar, BtnEdit, ModalPadrao, LabelPadrao, InputPadrao, CheckBoxPadrao, LoadingContainerPadrao, BtnIncluir } from "../../../components/Base";
import { Divider, Tooltip, Drawer, Radio, Input, Tabs } from "antd";
import TabelaPadrao from "../../../components/TabelaPadrao";
import * as api from "./api";
import { useFetch, useSave } from "../../../components/Hooks/Conexao";
import Mensagens from "../../../components/Mensagens";
import { PlusOutlined, RightOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { logIn, fetch } from "../../../actions/index";
import DrawerFiltros from "../../Shared/DrawerFiltros";
import SelectFiltros from "../../../components/SelectFiltros";
import SelectEstadosCidades from "../../../components/SelectEstadosCidades/SelectEstadosCidades";
import InputMask from './../../../components/InputMask';
import ExportacaoExcell from './ExportacaoExcell';

const { TabPane } = Tabs;
const { TextArea } = Input;

function Lojas(props) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [detalhe, setDetalhe] = useState(null);
  // const [drawerVisible, setDrawerVisible] = useState(false);

  const [filtros, setFiltros] = useState({});

  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nome",
      accessor: "nome",
    },
    {
      Header: " ",
      accessor: "idEmpresa",
      tipo: "right",
      Cell: data => {
        const row = data.row.original.idEmpresa;
        return (
          <div>
            <BtnEdit style={{ marginRight: 10 }} onClick={() => setDetalhe(row)} />
            <BtnDeletar
              onOk={() =>
                listarDados(
                  () => api.deletar(props.fetch, row),
                  () => {
                    const aux = [...dados];
                    aux.splice(
                      dados.findIndex(x => x.idEmpresa === row),
                      1
                    );
                    setDados(aux);
                    Mensagens.showSucesso("Loja deletada com sucesso!");
                  }
                )
              }
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    listarDados(() => api.getAll(props.fetch));
  }, []);

  function onOk(v) {
    const aux = [...dados];

    const regInx = aux.findIndex(x => x.idEmpresa === v.idEmpresa);

    if (regInx !== -1) {
      aux[regInx] = v;
    } else {
      aux.push(v);
    }

    setDados(aux);
    setDetalhe(null);
  }

  return (
    <>
      <Container loading={loading}>
        <div>
          <Divider orientation="left">Empresas</Divider>
          <div style={{ display: 'flex' }}>
            <div><BtnIncluir type="primary" onClick={() => setDetalhe(-1)} ghost /></div>
            <div><BtnPadrao type="primary" style={{ marginLeft: 10 }} onClick={() => listarDados(() => api.getAll(props.fetch, filtros))}>Listar</BtnPadrao></div>
            <div style={{ flex: 1, textAlign: 'right' }}><ExportacaoExcell dados={dados} /></div>
          </div>
        </div>
        <TabelaPadrao columns={columns} data={dados} style={{ margin: "25px 0" }} />
        {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
      </Container>
      <ModalInserir fetch={props.fetch} onCancel={() => setDetalhe(null)} onOk={onOk} id={detalhe} />
      {/* <DrawerFiltros filtros={filtros} lojas={dados} setFiltros={setFiltros} visible={drawerVisible} onCancel={() => setDrawerVisible(false)} /> */}
    </>
  );
}

export default connect(null, { logIn, fetch })(Lojas);

function ModalInserir({ id, onOk, onCancel, fetch, ...props }) {
  const [dados, listarDados, loading, setDados] = useFetch();
  const [save, saving] = useSave(
    () => api.post(fetch, dados),
    v => {
      if (v) onOk({ ...dados, idEmpresa: v });
      else onOk(dados);
      Mensagens.showSucesso("Dados salvos com sucesso!");
    }
  );

  useEffect(() => {
    if (id) listarDados(() => api.getDetalhe(fetch, id));
  }, [id]);

  function checkSave() {
    if (!dados.nome) {
      Mensagens.showErro("Dados não preenchidos!");
      return;
    }
    save();
  }

  return (
    <ModalPadrao
      visible={id}
      onCancel={onCancel}
      title="Empresas"
      destroyOnClose
      width={800}
      footer={null
        // <>
        //   <BtnPadrao type="primary" onClick={checkSave} loading={saving}>
        //     Gravar
        //   </BtnPadrao>
        //   <BtnPadrao type="primary" onClick={onCancel} ghost>
        //     Sair
        //   </BtnPadrao>
        // </>
      }
    >
      <LoadingContainerPadrao loading={loading}>
        {dados && (<Tabs defaultActiveKey="1" style={{ minHeight: 400 }}>
          <TabPane tab="Dados" key="1">
            <div style={{ width: "100%", marginRight: 10, display: 'flex' }}>
              <div style={{ flex: 1, marginRight: 5 }}>
                <LabelPadrao>Código</LabelPadrao>
                <InputPadrao value={dados.codigo} disabled />
              </div>
              <div style={{ flex: 2 }}>
                <LabelPadrao>Cnpj</LabelPadrao>
                <InputMask mask="99.999.999/9999-99" value={dados.cnpj} onChange={v => setDados({ ...dados, cnpj: v.target.value })} />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Nome</LabelPadrao>
              <InputPadrao value={(dados || {}).nome} onChange={v => setDados({ ...dados, nome: v.target.value })} autoFocus />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Razão Social</LabelPadrao>
              <InputPadrao value={(dados || {}).razaoSocial} onChange={v => setDados({ ...dados, razaoSocial: v.target.value })} autoFocus />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Fantasia</LabelPadrao>
              <InputPadrao value={(dados || {}).fantasia} onChange={v => setDados({ ...dados, fantasia: v.target.value })} autoFocus />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Email</LabelPadrao>
              <InputPadrao value={dados.email} onChange={v => setDados({ ...dados, email: v.target.value })} />
            </div>

            <div style={{ width: "100%" }}>
              <LabelPadrao>Inscrição estadual</LabelPadrao>
              <InputPadrao value={dados.ie} onChange={v => setDados({ ...dados, ie: v.target.value })} />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Endereço</LabelPadrao>
              <InputPadrao value={dados.rua} onChange={v => setDados({ ...dados, rua: v.target.value })} />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Complemento</LabelPadrao>
              <InputPadrao value={dados.complemento} onChange={v => setDados({ ...dados, complemento: v.target.value })} />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Bairro</LabelPadrao>
              <InputPadrao value={dados.bairro} onChange={v => setDados({ ...dados, bairro: v.target.value })} />
            </div>

            <SelectEstadosCidades
              estado={dados.estado}
              cidade={dados.cidade}
              setCidade={v => setDados({ ...dados, cidade: v })}
              setEstado={v => setDados({ ...dados, estado: v })}
            />

            <div style={{ width: "100%" }}>
              <LabelPadrao>Cep</LabelPadrao>
              <InputPadrao mask='99.999-999' value={dados.cep} onChange={v => setDados({ ...dados, cep: v.target.value })} />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Responsável</LabelPadrao>
              <InputPadrao value={dados.responsavel} onChange={v => setDados({ ...dados, responsavel: v.target.value })} />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Telefone</LabelPadrao>
              <InputPadrao mask='(99)9999-99999' value={dados.telefone} onChange={v => setDados({ ...dados, telefone: v.target.value })} />
            </div>
            <div style={{ width: "100%" }}>
              <LabelPadrao>Celular</LabelPadrao>
              <InputPadrao mask='(99)9999-99999' value={dados.celular} onChange={v => setDados({ ...dados, celular: v.target.value })} />
            </div>

          </TabPane>

          <TabPane tab="Características" key="2">
            <LabelPadrao>Segmento</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=segmento" value={dados.idSegmento} onChange={v => setDados({ ...dados, idSegmento: v })} />
            <LabelPadrao>Faixa de Faturamento</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=fxFaturamento" value={dados.idFxFaturamento} onChange={v => setDados({ ...dados, idFxFaturamento: v })} />
            <LabelPadrao>Porte do PDV</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=portepdv" value={dados.idPortePdv} onChange={v => setDados({ ...dados, idPortePdv: v })} />
            <LabelPadrao>Modelo de Negocio</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=modeloneg" value={dados.idModeloNegocio} onChange={v => setDados({ ...dados, idModeloNegocio: v })} />
            <LabelPadrao>Tipo de Empresa</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=tipoemp" value={dados.idTipoEmpresa} onChange={v => setDados({ ...dados, idTipoEmpresa: v })} />
            <LabelPadrao>Perfil</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=perfil" value={dados.idPerfil} onChange={v => setDados({ ...dados, idPerfil: v })} />
            <LabelPadrao>Região Comercial</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=rgComer" value={dados.idRgComer} onChange={v => setDados({ ...dados, idRgComer: v })} />
            <LabelPadrao>Região Geografica</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=rgGeo" value={dados.idRgGeo} onChange={v => setDados({ ...dados, idRgGeo: v })} />

            <LabelPadrao>Rede</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=rede" value={dados.idRede} onChange={v => setDados({ ...dados, idRede: v })} />
            <LabelPadrao>Federação</LabelPadrao>
            <SelectFiltros modelo="caracteristica?filtro=federacao" value={dados.idFederacao} onChange={v => setDados({ ...dados, idFederacao: v })} />


          </TabPane>
          <TabPane tab="Observações" key="3">
            <TextArea rows={10} value={dados.obs} onChange={e => setDados({ ...dados, obs: e.target.value })} />
          </TabPane>
        </Tabs>)}
        <div className="sticky-bottom" style={{ textAlign: 'right', paddingTop: 15, backgroundColor: 'white' }}>
          <BtnPadrao type="primary" onClick={checkSave} loading={saving} disabled={!dados} style={{ marginRight: 8 }}>Gravar</BtnPadrao>
          <BtnPadrao type="primary" onClick={onCancel} ghost>Sair</BtnPadrao>
        </div>
      </LoadingContainerPadrao>
    </ModalPadrao>
  );
}
